import * as React from 'react';
import { patientHeader, UserSelectBody, Type, checkedUserIds } from './UserListField';
// import { Male, Female } from '../constants/UserListField';
import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import '../css/modal_layout.css';
import * as Header from '../constants/Header';
import { Dialog, Button, Form, Input, DatePicker, Radio, Select, Message  } from 'element-react';
import { Patient, Hospital } from '@src/interfaces';
import Back from './common/Back';
import { createBlobJSON2CSV, createBlobCSV } from '../utils/commonUtil';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import * as moment from 'moment';

interface PatientListProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;
}

interface ListState {
  showAddDialog: boolean;
  form: Patient;
  download: boolean;
}

class PatientList extends React.Component<PatientListProps, ListState> {

  patientsListOriginal: any;
  isStartedFilter: boolean;

  constructor(props: any) {
    super(props);
    this.state = {
      showAddDialog: false,
      form: {
        heartRate: 0,
        gender: 1,
        birthdayYmd: null,
        hospitalIds: [],
        username: '',
        password: ''
      },
      download: false,
    };
    this.patientsListOriginal = {};
    this.isStartedFilter = false;
  }

  onChange(key: string, value: any) {
    if (key === 'gender') {
      this.state.form[key] = Number(value);
    } else if (key === 'filterUsername') {
      this.state.form.username = value;
      // 絞り込み
      if (!this.isStartedFilter) {
        this.patientsListOriginal = this.props.moffAPI.patients;
        this.isStartedFilter = true;
      }
      if (this.patientsListOriginal)
      this.props.moffAPI.patients = this.patientsListOriginal.filter((v) => v.username.match(this.state.form.username));
    } else {
      this.state.form[key] = value;
    }
    this.forceUpdate();
  }

  onSubmit() {
    if (this.state.form.username.length < 6)
      return Message({
        type: 'error',
        duration: 3000,
        message: 'ユーザIDは６文字以上で入力してください'
      });
    if (this.state.form.password.length < 8)
      return Message({
        type: 'error',
        duration: 3000,
        message: 'パスワードは8文字以上で入力してください'
      });
    if (!(/[0-9]+/.test(this.state.form.password)) || !(/[a-zA-Z]+/.test(this.state.form.password))) {
      return Message({
        type: 'error',
        duration: 3000,
        message: 'パスワードは半角英数字で入力してください'
      });
    }
    this.props.moffAPIActions.postAddPatient(this.state.form);
    this.setState({ showAddDialog: false });
  }

  reduceHospitals() {
    return this.props.moffAPI.hospitals.map((v: Hospital) => {
      return {
        value: v.id,
        label: v.name
      };
    });
  }
  
  handleFieldClickPatient = (index: number) => {
    const targetId = this.props.moffAPI.patients[index].id;
    window.location.href = `/patient/${targetId}`;
  }

  componentWillMount() {
    document.title = '顧客一覧画面';

    this.props.headerActions.setPage(Header.PATIENT_LIST);

    // Action
    this.props.moffAPIActions.getAllPatients();

  }

  createAerobicCustomCsv(csvDataOfAerobic: any, fieldsOfAerobic: any, unwindOfAerobic: any) {
    // 有酸素運動の心拍ログ出力カスタマイズの出力用配列
    let csvDataOfAerobicCustom: string[][] = new Array();
    // 有酸素運動のcsvデータカスタマイズ
    const { Parser } = require('json2csv');
    const json2csvParser = new Parser({ fields: fieldsOfAerobic , flattern: true, unwind: unwindOfAerobic});
    let aerobicData;
    try {
      aerobicData = json2csvParser.parse(csvDataOfAerobic); 
    } catch (error) {
      console.log(error);
    }
    // 出力のための変数
    let splitedHeartRates;
    let heartRateLogsStartedAt;
    let columnValues = [];
    let lineCounter = 0;
    // csvを入力配列に読み込む
    let heartRateLogsIndex;
    let heartRateLogsStartedAtIndex;
    let dayTrainingNumberIndex;
    let trainingNumberIndex;
    let startedAtIndex;
    let finishedAtIndex;
    let evaluationIndex;
    let aerobicNumberIndex;
    let nameIndex;
    let labelIndex;
    let minIndex;
    let maxIndex;
    // let aerobicMotionNumbersIndex;
    let goalDurationMinutesIndex;
    let stoppedCountIndex;
    // let actualDurationMinutesIndex;
    // let heartRateLogsFinishedAtIndex;
    const csv2array  = require('csv2array');
    csv2array(aerobicData).forEach((line, index) => {
      if (index === 0) {
        // ヘッダ
        let writeLine = '';
        // tslint:disable-next-line: forin
        for (let key in line) {
          if (line[key] === 'aerobicLog.heartRateLogs.heartRates') {
            heartRateLogsIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.heartRateLogs.startedAt') {
            heartRateLogsStartedAtIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'dayTrainingNumber') {
            dayTrainingNumberIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'trainingNumber') {
            trainingNumberIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'startedAt') {
            startedAtIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'finishedAt') {
            finishedAtIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'evaluation') {
            evaluationIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.aerobicNumber') {
            aerobicNumberIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.name') {
            nameIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.label') {
            labelIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.min') {
            minIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.max') {
            maxIndex = key;
            writeLine += line[key] + ',';
          // } else if (line[key] === 'aerobicLog.aerobicMotionNumbers') {
          //   aerobicMotionNumbersIndex = key;
          } else if (line[key] === 'aerobicLog.goalDurationMinutes') {
            goalDurationMinutesIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.stoppedCount') {
            stoppedCountIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.actualDurationMinutes') {
          //   actualDurationMinutesIndex = key;
            writeLine += line[key] + ',';
          } else if (line[key] === 'aerobicLog.heartRateLogs.finishedAt') {
          //   heartRateLogsFinishedAtIndex = key;
            writeLine += line[key];
          }
        }
        // ヘッダ
        csvDataOfAerobicCustom[lineCounter] = [];
        csvDataOfAerobicCustom[lineCounter].push(writeLine);
        lineCounter += 1;
      } else {
        // 2行目以降の処理
        // 心拍数を配列に入れる
        for (let key in line) {
          //  各項目の値を保存
          if (key ===  heartRateLogsIndex) {
            splitedHeartRates = line[key];
            columnValues.push(line[key]);
          } else if (key === startedAtIndex) {
            columnValues.push(line[key]);
          } else if (key === heartRateLogsStartedAtIndex) {
            heartRateLogsStartedAt = line[key];
            columnValues.push(line[key]);
          } else {
            columnValues.push(line[key]);
          }
        }
        splitedHeartRates = splitedHeartRates.replace('[', '');
        splitedHeartRates = splitedHeartRates.replace(']', '');
        splitedHeartRates = splitedHeartRates.split(',');
        // 1秒ごとの心拍数の値で1列を作る
        let timeCounter = 0;
        for (let key in splitedHeartRates) {
          if (splitedHeartRates[key]) {
            let writeLine = columnValues[dayTrainingNumberIndex] + ',' +
                columnValues[trainingNumberIndex] + ',' +
                columnValues[startedAtIndex] + ',' +
                columnValues[finishedAtIndex] + ',' +
                columnValues[evaluationIndex] + ',' +
                columnValues[aerobicNumberIndex] + ',' +
                columnValues[nameIndex] + ',' +
                columnValues[labelIndex] + ',' +
                columnValues[minIndex] + ',' +
                columnValues[maxIndex] + ',' +
                // columnValues[aerobicMotionNumbersIndex] + ',' +
                columnValues[goalDurationMinutesIndex] + ',' +
                columnValues[stoppedCountIndex] + ',' +
                '1,';
            writeLine = writeLine + splitedHeartRates[key] + ',';
            writeLine = writeLine + moment(heartRateLogsStartedAt).add(timeCounter, 's').format('YYYY-MM-DD HH:mm:ss').toString() + ',';
            writeLine = writeLine + moment(heartRateLogsStartedAt).add(timeCounter + 1, 's').format('YYYY-MM-DD HH:mm:ss').toString();
            timeCounter += 1;
            // 出力用配列をCSVに書き出し
            csvDataOfAerobicCustom[lineCounter] = [];
            csvDataOfAerobicCustom[lineCounter].push(writeLine);
            lineCounter += 1;
          }
        }
        columnValues = [];
      }
    });
    return csvDataOfAerobicCustom;
  }

  runDownload() {
    // 運動実施ログからcsvをつくる
    this.setState({download: false});

    let zip = new JSZip();

    if (this.props.moffAPI.Loaded) {
      const patientsDayTrainingLogs = this.props.moffAPI.patientsDayTrainingLogs;
      if (patientsDayTrainingLogs.length < 1)  {
        return;
      }

      let csvDataOfResistance = {};
      const fieldsOfResistance = ['dayTrainingNumber', 'trainingNumber', 'startedAt', 'finishedAt', 'evaluation', 'patientDayTrainingResistanceLogs.resistanceNumber', 'patientDayTrainingResistanceLogs.name', 'patientDayTrainingResistanceLogs.level', 'patientDayTrainingResistanceLogs.stoppedCount', 'patientDayTrainingResistanceLogs.evaluation', 'patientDayTrainingResistanceLogs.depthRepsThreshold', 'patientDayTrainingResistanceLogs.depthSuccessThreshold', 'patientDayTrainingResistanceLogs.form', 'patientDayTrainingResistanceLogs.reps', 'patientDayTrainingResistanceLogs.sets', 'patientDayTrainingResistanceLogs.setLogs.isSuccess', 'patientDayTrainingResistanceLogs.setLogs.depth', 'patientDayTrainingResistanceLogs.setLogs.form', 'patientDayTrainingResistanceLogs.setLogs.startedAt', 'patientDayTrainingResistanceLogs.setLogs.finishedAt'];
      const unwindOfResistance = ['patientDayTrainingResistanceLogs', 'patientDayTrainingResistanceLogs.setLogs'];
      let csvDataOfAerobic = {};
      const fieldsOfAerobic = ['dayTrainingNumber', 'trainingNumber', 'startedAt', 'finishedAt', 'evaluation', 'aerobicLog.aerobicNumber', 'aerobicLog.name', 'aerobicLog.label', 'aerobicLog.min', 'aerobicLog.max', 'aerobicLog.aerobicMotionNumbers', 'aerobicLog.goalDurationMinutes', 'aerobicLog.stoppedCount', 'aerobicLog.actualDurationMinutes', 'aerobicLog.heartRateLogs.heartRates', 'aerobicLog.heartRateLogs.startedAt', 'aerobicLog.heartRateLogs.finishedAt'];
      const unwindOfAerobic = ['aerobicLog', 'aerobicLog.heartRateLogs', 'aerobicLog.heartRateLogs'];
      
      // ユーザー別のログデータ処理
      for (let dayTrainingLogs of patientsDayTrainingLogs) {
        let trainingLogs;
        if (dayTrainingLogs.patientDayTrainingLogs) {
          trainingLogs = dayTrainingLogs.patientDayTrainingLogs;
        } else {
          trainingLogs = dayTrainingLogs;
        }
        // アカウント名
        if (trainingLogs.length === 0) {
          continue;
        }
        let patientId;
        trainingLogs.forEach((dayTrainingLog, index) => {
          if (index === 0) {
            patientId = dayTrainingLog.patientId;
          }
        });
        let username = this.props.moffAPI.patients.find( user => user.id === patientId).username;

        // レジスタンス運動データ
        const keyOfResistance = ['dayTrainingNumber', 'trainingNumber', 'startedAt', 'finishedAt', 'evaluation', 'patientDayTrainingResistanceLogs'];
        let dayOfResistance = [];
        trainingLogs.forEach(element => {
          let row = {};
          keyOfResistance.forEach(key => {
            if (key === 'startedAt' || key === 'finishedAt') {
              row[key] = moment(element[key]).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
            } else if (key === 'patientDayTrainingResistanceLogs') {
              element[key].forEach(set => {
                set.setLogs.forEach(log => {
                  log.startedAt = moment(log.startedAt).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
                  log.finishedAt = moment(log.finishedAt).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
                });
              });
              row[key] = element[key];
            } else {
              row[key] = element[key];
            }
          });
          dayOfResistance.push(row);
        });
        csvDataOfResistance = dayOfResistance;
        const resistanceBlob = createBlobJSON2CSV(csvDataOfResistance, username + '-resistanceLog', fieldsOfResistance, unwindOfResistance);
        zip.file(username + '-resistanceLog.csv', resistanceBlob);

        // 有酸素運動データ
        const keyOfAerobic = ['dayTrainingNumber', 'trainingNumber', 'startedAt', 'finishedAt', 'evaluation', 'aerobicLog'];
        let dayOfAerobic = [];
        trainingLogs.forEach(element => {
          let row = {};
          keyOfAerobic.forEach(key => {
            if (key === 'startedAt' || key === 'finishedAt') {
              row[key] = moment(element[key]).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
            } else if (key === 'aerobicLog') {
              element[key].heartRateLogs.forEach(log => {
                log.startedAt = moment(log.startedAt).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
                log.finishedAt = moment(log.finishedAt).add(9, 'h').format('YYYY-MM-DD HH:mm:ss').toString();
              });
              row[key] = element[key];
            } else {
              row[key] = element[key];
            }
          });
          dayOfAerobic.push(row);
        });
        csvDataOfAerobic = dayOfAerobic;
        const aerobicBlob = createBlobJSON2CSV(csvDataOfAerobic, username + '-aerobicLog', fieldsOfAerobic, unwindOfAerobic);
        zip.file(username + '-aerobicLog.csv', aerobicBlob);

        // 有酸素運動データカスタマイズ
        const csvDataOfAerobicCustom = this.createAerobicCustomCsv(csvDataOfAerobic, fieldsOfAerobic, unwindOfAerobic);
        const aerobicCustomBlob = createBlobCSV(csvDataOfAerobicCustom, username + '-aerobicLogCustom');
        zip.file(username + '-aerobicLogCustom.csv', aerobicCustomBlob);

      }
      if (zip.files !== undefined) {
        zip.generateAsync({type: 'blob'})
          .then(content => {
            // see FileSaver.js
            saveAs(content, 'data.zip');
        });
      }
    }
  }

  render() {
    return (
      <div>
        <Dialog
          title="顧客追加"
          size="tiny"
          visible={this.state.showAddDialog}
          onCancel={() => this.setState({ showAddDialog: false })}
          lockScroll={false}
        >
          <Dialog.Body>
            <p>
              ※ユーザIDは6文字以上
              <br />
              パスワードは英数字8文字以上
            </p>
            <Form model={this.state.form} labelWidth="120">
              <Form.Item label="ユーザID">
                <Input value={this.state.form.username} onChange={this.onChange.bind(this, 'username')} />
              </Form.Item>
              <Form.Item label="パスワード">
                <Input value={this.state.form.password} onChange={this.onChange.bind(this, 'password')} />
              </Form.Item>
              <Form.Item label="生年月日">
                <DatePicker
                  value={this.state.form.birthdayYmd}
                  placeholder="生年月日を選択してください"
                  onChange={this.onChange.bind(this, 'birthdayYmd')}
                />
              </Form.Item>
              <Form.Item label="所属医療機関">
                <Select placeholder="所属医療機関を選択してください" value={this.state.form.hospitalIds} multiple={true} onChange={this.onChange.bind(this, 'hospitalIds')}>
                  {
                    this.reduceHospitals().map(el => {
                      return <Select.Option key={el.value} label={el.label} value={el.value} />;
                    })
                  }
                </Select>
              </Form.Item>
              <Form.Item label="性別">
                <Radio value="1" checked={this.state.form.gender === 1} onChange={this.onChange.bind(this, 'gender')}>男性</Radio>
                <Radio value="2" checked={this.state.form.gender === 2} onChange={this.onChange.bind(this, 'gender')}>女性</Radio>
              </Form.Item>
              <Form.Item label="心拍数">
                <Input value={this.state.form.heartRate} onChange={this.onChange.bind(this, 'heartRate')} />
              </Form.Item>
            </Form>
          </Dialog.Body>
          <Dialog.Footer className="dialog-footer">
            <Button onClick={() => this.setState({ showAddDialog: false })}>キャンセル</Button>
            <Button type="primary" onClick={() => this.onSubmit()}>顧客登録</Button>
          </Dialog.Footer>
        </Dialog>
        <Back />
        <div className="btnStyle02">
          {/*
          <Button>全て選択/解除</Button>
           */}
          <Button onClick={() => this.runDownload()}>データダウンロード</Button>
          <Button onClick={() => this.setState({ showAddDialog: true })}>顧客登録</Button>
          <Input type="text" className="filter_text" name="filter_text"  placeholder="ユーザIDを入力して絞り込み"  value={this.state.form.username} onChange={this.onChange.bind(this, 'filterUsername')} />
        </div>
        <div id="userlist">
          <table className="tblStyle01">
            <thead>
              <tr>
                {patientHeader}
              </tr>
            </thead>
            <tbody>
              <UserSelectBody
                type={Type.Patient}
                patients={this.props.moffAPI.patients}
                checkedUserIds={checkedUserIds}
                moffAPI={this.props.moffAPI}
                moffAPIActions={this.props.moffAPIActions}
                download={this.state.download}
              />
            </tbody>
          </table>
        </div>
        <style type="text/css">
          {'#wrapper .contentIn { padding-top: 50px;text-align: left; }'}
          {'.btnStyle02 { margin-bottom: 16px;text-align: left;max-width: 100%; }'}
          {'.btnStyle02 button{ margin-right: 10px; }'}
          {'td a { color: #23527c;}'}
          {'td a:hover { text-decoration: underline;opacity: 0.8;}'}
          {'td a:before { content:"- "}'}
          {'.filter_wrap { padding-left: 10px; text-align: left;  }'}
          {'input[type="text"] { background: #F4F8FA; margin-top: 10px; padding: 0; border-style: ridge; outline: none; -webkit-appearance: none; -moz-appearance: none; appearance: none; padding: 10px 20px; width: 500px; margin-bottom: 00px; border-radius: 4px; }'}
        </style>
      </div>
    );
  }
  /**
   * 男性、女性表示.
   *
   * @param {number} gender
   * @returns {string}
   * @memberof MoffCheck
   */
  // private getGender(gender: number): string {
  //   return `${gender === 1 ? Male : Female}性`;
  // }
}

export default PatientList;



// WEBPACK FOOTER //
// ./src/components/PatientList.tsx